//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { clearTimeout, setTimeout } from "timers";
// chrome-fatal-error imports
import { IProps } from "./ChromeFatalError.d";
import * as s from "./ChromeFatalError.styles";
// state
// util
import { logger } from "@util/logger.util";
import { windowLocation } from "@util/location.util";
import { calculateBackoffTimeout } from "@clockwise/client-commons/src/util/network";
// other internals
import { asCard, CardButton } from "@components/card";
import { H5 } from "@ui";
import { constructionBlockSvg } from "@img/illustrations";
import { useSelector } from "react-redux";
import { IReduxState } from "@reducers/root.reducer";
const constructionBGcolor = "#89c6a9";

//////////////////
// COMPONENT
//////////////////
const ChromeFatalErrorCmpt = (_props: IProps) => {
  const networkFailureScale = useSelector((state: IReduxState) => state.shared.networkFailureScale);

  const reload = () => {
    logger.debug("reloading page after error timeout");
    windowLocation.reload("ChromeFatalError");
  };

  React.useEffect(() => {
    const timeout = setTimeout(() => reload, calculateBackoffTimeout(networkFailureScale));

    return () => clearTimeout(timeout);
  }, [networkFailureScale]);

  const headerBgStyle = s.getCardHeader(constructionBlockSvg, constructionBGcolor);
  return (
    <div style={s.container}>
      <div style={headerBgStyle}></div>
      <div style={s.cardContent}>
        <H5 style={s.h5}>Oops! Something went wrong.</H5>
        <div style={s.p}>
          We are having some technical difficulties. We will try again in a few moments or you may
          use the button below to reload Clockwise.
        </div>
      </div>
      <div style={s.actions}>
        <CardButton style={s.button} onClick={reload} label="Reload" />
      </div>
    </div>
  );
};

export const ChromeFatalError = asCard<IProps>(ChromeFatalErrorCmpt);
